import { When } from 'react-if';
import styled from 'styled-components6';

const PoweredByContainer = styled.div<{
    isMapWidget: boolean;
    isStatic: boolean;
}>`
    position: ${({ isStatic }) => (isStatic ? 'relative' : 'absolute')};
    right: 0;
    padding: 5px;
    margin-top: 2px;
    font-size: 11px;
    border-right: ${({ isMapWidget }) =>
        isMapWidget ? null : ' 1px solid rgba(0, 0, 0, 0.2);'};
`;

const PoweredByContent = styled.div`
    color: #6c6c6c;
    border-radius: 2px;
    text-align: left;
    padding: 2px;
`;

export default function PoweredBy({
    display,
    isMapWidget,
    isStatic = false,
}: {
    display: boolean;
    isMapWidget: boolean;
    isStatic?: boolean;
}) {
    return (
        <When condition={display}>
            <PoweredByContainer isMapWidget={isMapWidget} isStatic={isStatic}>
                <PoweredByContent>
                    <span
                        style={{
                            position: 'relative',
                            top: '-6px',
                        }}
                    >
                        Powered by{' '}
                    </span>
                    <img
                        style={{
                            height: '14px',
                        }}
                        alt={'RealWork Logo'}
                        src={
                            'https://app.realworklabs.com/poweredByLogoDark.png'
                        }
                    />
                </PoweredByContent>
            </PoweredByContainer>
        </When>
    );
}
